import { isEscape, returnFocus, trapFocus, throttle } from "./app/utils.js";

var returnFocusTo = window.returnFocusTo || null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.getElementById('listing-content-dialog');

    if (!dialog) {
        return;
    }

    const title = dialog.querySelector('#listing-content-dialog-title');
    const body = dialog.querySelector('#listing-content-dialog-body');
    const closeButton = dialog.querySelector('.listing-content-dialog__close');

    document.querySelectorAll('[data-listing-modal-content]').forEach(button => {
        button.addEventListener('click', event => {
            event.preventDefault();

            const content = document.getElementById(button.dataset.listingModalContent);
            if (!content) {
                return;
            }

            title.textContent = button.dataset.listingModalTitle;
            body.replaceChildren(content.content.cloneNode(true));
            dialog.showModal();
            closeButton.focus();
        });
    });

    closeButton.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
        if (event.target === dialog) {
            dialog.close();
        }
    });
});

const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
if (!!isReduced) {
    const heroVideo = document.querySelector('.wp-block-pulp-hero video');
    if (heroVideo) {
        heroVideo.pause();
    }
}

/*
Mobile UI
*/
document.getElementById('site-navigation-toggle').addEventListener('click', e => {
    e.preventDefault();
    const nav = document.getElementById('primary-navigation');
    const hamburgerIcon = document.getElementById('site-navigation-toggle-icon-hamburger');
    const closeIcon = document.getElementById('site-navigation-toggle-icon-close');
    
    nav.classList.toggle('open');
    
    if (nav.classList.contains('open')) {
        hamburgerIcon.style.display = 'none';
        closeIcon.style.display = 'inline-block';
    } else {
        hamburgerIcon.style.display = 'inline-block';
        closeIcon.style.display = 'none';
    }
});

/*
Scroll events
*/
// window.addEventListener('scroll', throttle(100, function () {
//     if (window.scrollY > 50) {
//         document.body.classList.add('is-scrolled');
//         return;
//     }
//     document.body.classList.remove('is-scrolled');
// }));

/*
Gallery Modal
*/
document.addEventListener('DOMContentLoaded', () => {
    function initializeGallery(modalId, imageSelector, buttonIds = []) {
        const modal = document.getElementById(modalId);
        const galleryImages = document.querySelectorAll(imageSelector);

        if (!modal || galleryImages.length === 0) {
            return;
        }

        const modalImage = modal.querySelector('.gallery-modal__image');
        const modalOverlay = modal.querySelector('.gallery-modal__overlay');
        const closeBtn = modal.querySelector('.gallery-modal__close');
        const prevBtn = modal.querySelector('.gallery-modal__prev');
        const nextBtn = modal.querySelector('.gallery-modal__next');
        const currentCounter = modal.querySelector('.gallery-modal__current');
        const totalCounter = modal.querySelector('.gallery-modal__total');
        const modalLinkContainer = modal.querySelector('.gallery-modal__link');
        const modalLink = modalLinkContainer ? modalLinkContainer.querySelector('a') : null;
        const galleryData = Array.from(galleryImages).map(img => ({
            src: img.src,
            alt: img.alt,
            link: img.getAttribute('data-gallery-link') || '',
            linkTitle: img.getAttribute('data-gallery-link-title') || 'View Photo'
        }));
        let currentIndex = 0;
        let activeImage = null;

        totalCounter.textContent = galleryData.length;

        function updateImage() {
            const imageData = galleryData[currentIndex];
            modalImage.src = imageData.src;
            modalImage.alt = imageData.alt;
            currentCounter.textContent = currentIndex + 1;

            if (modalLinkContainer && modalLink) {
                if (imageData.link) {
                    modalLink.href = imageData.link;
                    modalLink.textContent = imageData.linkTitle;
                    modalLinkContainer.style.display = 'block';
                } else {
                    modalLinkContainer.style.display = 'none';
                }
            }

            prevBtn.disabled = currentIndex === 0;
            nextBtn.disabled = currentIndex === galleryData.length - 1;
        }

        function openModal(index, trigger) {
            currentIndex = index;
            activeImage = trigger || null;
            updateImage();
            modal.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            closeBtn.focus();
        }

        function closeModal() {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
            if (activeImage) {
                activeImage.focus();
            }
        }

        function showPrevImage() {
            if (currentIndex > 0) {
                currentIndex--;
                updateImage();
            }
        }

        function showNextImage() {
            if (currentIndex < galleryData.length - 1) {
                currentIndex++;
                updateImage();
            }
        }

        galleryImages.forEach((img, index) => {
            img.addEventListener('click', () => openModal(index, img));
            img.setAttribute('tabindex', '0');
            img.setAttribute('role', 'button');
            img.addEventListener('keydown', event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    openModal(index, img);
                }
            });
        });

        closeBtn.addEventListener('click', closeModal);
        modalOverlay.addEventListener('click', closeModal);
        prevBtn.addEventListener('click', showPrevImage);
        nextBtn.addEventListener('click', showNextImage);
        modal.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                closeModal();
            } else if (event.key === 'ArrowLeft') {
                showPrevImage();
            } else if (event.key === 'ArrowRight') {
                showNextImage();
            }
        });

        buttonIds.forEach(buttonId => {
            const button = document.getElementById(buttonId);
            if (!button) {
                return;
            }

            button.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                openModal(0, button);
            });
        });
    }

    initializeGallery('gallery-modal', '.gallery-image', ['gallery-button', 'gallery-more-button']);
});
